const CLASS = "-active"
let flg = false

const humBurger = document.querySelector("#jsHumBurger") as HTMLElement // ハンバーガーボタンの要素を取得
const jsHumBurgerLine = document.querySelector("#jsHumBurgerLine") as HTMLElement // ハンバーガーボタンの線の要素を取得
const focusTrap = document.querySelector("#jsFocusTrap") as HTMLElement // フォーカスがトラップされる要素を取得
const menu = document.querySelector(".jsNavArea") as HTMLElement // メニューの要素を取得
const body = document.querySelector("body") as HTMLElement // ボディ要素を取得
const conversationButton = document.getElementById('jsContactButton') as HTMLElement // 会話ボタンの要素を取得

humBurger.addEventListener("click", function() {
  this.classList.toggle(CLASS) // ハンバーガーボタンにクラスを切り替える
  jsHumBurgerLine.classList.toggle(CLASS) // ハンバーガーボタンの線にクラスを切り替える
  menu.classList.toggle(CLASS) // メニューにクラスを切り替える
  body.classList.toggle(CLASS) // ボディにクラスを切り替える
  conversationButton.classList.toggle(CLASS) // 会話ボタンにクラスを切り替える
  conversationButton.style.display = 'none' // 会話ボタンを非表示にする
  if (flg) {
    humBurger.setAttribute("aria-expanded", "false") // ハンバーガーボタンの属性を設定
    humBurger.focus() // ハンバーガーボタンにフォーカスを設定
    flg = false
  } else {
    humBurger.setAttribute("aria-expanded", "true") // ハンバーガーボタンの属性を設定
    flg = true
  }
})

window.addEventListener("keydown", function(e) {
  if (e.key === "Escape") {
    humBurger.classList.remove(CLASS) // ハンバーガーボタンからクラスを削除
    jsHumBurgerLine.classList.remove(CLASS) // ハンバーガーボタンの線からクラスを削除
    menu.classList.remove(CLASS) // メニューからクラスを削除
    body.classList.remove(CLASS) // ボディからクラスを削除
    conversationButton.classList.toggle(CLASS)
    humBurger.focus() // ハンバーガーボタンにフォーカスを設定
    humBurger.setAttribute("aria-expanded", "false") // ハンバーガーボタンの属性を設定
    flg = false
  }
})

focusTrap.addEventListener("focus", function() {
  humBurger.focus() // ハンバーガーボタンにフォーカスを設定
})

const pageLinks = document.querySelectorAll("a.pageLink")
pageLinks.forEach(function(link) {
  link.addEventListener("click", function() {
    humBurger.classList.remove(CLASS) // ハンバーガーボタンからクラスを削除
    jsHumBurgerLine.classList.remove(CLASS) // ハンバーガーボタンの線からクラスを削除
    menu.classList.remove(CLASS) // メニューからクラスを削除
    body.classList.remove(CLASS) // ボディからクラスを削除
    conversationButton.classList.toggle(CLASS)
    humBurger.focus() // ハンバーガーボタンにフォーカスを設定
    humBurger.setAttribute("aria-expanded", "false") // ハンバーガーボタンの属性を設定
    flg = false
  })
})
